// extracted by mini-css-extract-plugin
export default {"sch_chart":"sch_chart","sch_errorMessage":"sch_errorMessage"};